module.exports = __webpack_public_path__ + "img/icons8-check-all.86d4e59a.svg";